import { ReactNode } from "react";
import { cn } from "@/core/helpers/cn";

type Props = {
  text: string;
  isTop?: boolean;
  classNameChildren?: string;
  children?: ReactNode;
};

export default function FactionSettingsItem({ text, isTop, children, classNameChildren }: Props) {
  return (
    <div
      className={cn(
        "flex items-center w-full p-3.5 border-b border-x border-[#2A2A2A] overflow-clip",
        isTop && "border-t rounded-t-2xl",
      )}
    >
      <p className="relative z-1 text-14 font-medium leading-none transition-all duration-200">
        {text}
      </p>
      <div className={cn("ml-auto", classNameChildren)}>{children}</div>
    </div>
  );
}
